import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Header } from '../../../Header';
import className from '../style.module.scss';
import { FullscreenModal } from '@learningblocks/storybook-components/lib/FullscreenModal';
import './style.scss';
import { Clock, Pause, Play, Refresh } from '@learningblocks/storybook-components/lib/Icons';
import { splitTime } from '../Timer.utils';

import {useTranslation} from 'react-i18next';

const TRANSLATION_KEY = {
  Timer: 'Timer.string',
  Instruction: 'Instruction.string',
  Done: 'Done.string',
  Skip: 'Skip.string'
};

const DEFAULT_TIME = 946677600;

export function TimerPopup(props) {

  const {
    t,
    //i18n
  } = useTranslation();
  
  const format = (value) => (value >= 10 ? `${value}` : `0${value}`);
  
  const [hour, minute, second] = splitTime(props.time).map(format);

  const [percentage, setPercentage] = React.useState(0);

  useEffect(()=>{
    if(props.time === DEFAULT_TIME){
      setPercentage(0);
    } else {
      let percent = (
        (props.time - DEFAULT_TIME) / 
        (props.currentlySetTime - DEFAULT_TIME)
      ) * 100;
      setPercentage(100 - percent);
    }
  }, [props.time, props.currentlySetTime, props.running]);

  const renderSceneItemNote = () => (
    <div className={className.sceneItemNote}>
      <h4>{t(TRANSLATION_KEY.Timer)}</h4>
      <p>{t(TRANSLATION_KEY.Instruction)}</p>
    </div>
  )

  return (
    <FullscreenModal
      isOpen={props.isOpen}
      className={`${className.timerModal} timer_timerModal`}
      closeButton={true}
      close={props.onClose}
      notebookExpanded={props.notebookExpanded}>
      <Header
        className={className.timerModalHead}
        size={props.size}
      />
      <div className={className.section}>
        {renderSceneItemNote()}
        <div className={className.sectionRight}>{props.children}</div>
      </div>
      <div className={className.footer}>
        <div className={className.timerRunTrackerWrapper}>
          <div className={className.timeRunTracker}>
            {/*<button onClick={()=>(props.running)?props.pauseTimer():props.startTimer()}>
              <img src={(props.running)?Pause:Play} />
            </button>*/}
            <div className={className.progressTrackWrapper}>
              <div className={className.progressTrack} style={{
                  width: percentage + "%"
                }}>
                <img src={Clock} className={className.clockImage} />
              </div>
            </div>
            <button className={className.resetBtn} onClick={props.resetTimer}>
              <img src={Refresh} />
            </button>
          </div>
          <div className={className.skipBtnWrapper}>
            <button className={className.skipBtn} onClick={props.onFooterClick}>{(props.skipTimer)?t(TRANSLATION_KEY.Skip):t(TRANSLATION_KEY.Done)}</button>
            <p>{hour} : {minute} : {second}</p>
          </div>
        </div>
      </div>
    </FullscreenModal>
  );
}

TimerPopup.propTypes = {
  /**
   * Boolen to set if popup is open
   */
  isOpen: PropTypes.bool,
  /**
   * Callback to close Modal window
   */
  onClose: PropTypes.func,
  /**
   * TimerControl Component
   */
  children: PropTypes.element,
  /**
   * Boolean to show/hide SkipAhead Button and Message
   */
  skipTimer: PropTypes.bool,
  /**
   * Callback function for Footer button
   */
  onFooterClick: PropTypes.func,
};

TimerPopup.defaultProps = {
  size: 'md',
  skipTimer: undefined,
};
